import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import TextField from '@material-ui/core/TextField';
import 'react-datepicker/dist/react-datepicker.css';
import './DateTimePicker.css';

class DateTimePicker extends React.Component {
    handleChange(date) {
        this.setState({
            startDate: date
        });
    }

    render() {
        return (
            <div className='pdc-datepicker-popover'>
                <DatePicker
                    customInput={<ExampleCustomInput label={this.props.label} disabled={this.props.disabled} />}
                    {...this.props}
                    popperClassName='pdc-datepicker-popper'
                />
            </div>
        );
    }
}
DateTimePicker.propTypes = {
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

class ExampleCustomInput extends React.Component {

    render() {
        return (
            <TextField
                style={{ width: '280px' }}
                id={this.props.label}
                label={this.props.label}
                value={this.props.value}
                onClick={this.props.onClick}
                margin="normal"
                disabled={this.props.disabled}
            />
        );
    }
}

ExampleCustomInput.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

export default DateTimePicker;